import React from 'react';
import { cn } from '../../utils/cn';

export type Variant = 'filled' | 'outlined' | 'text';

export interface CustomButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: Variant;
}

const baseClassName =
    'rounded-lg py-3 px-10 h-12 w-full md:max-w-80 w-full text-base font-semibold !leading-relaxed flex justify-center items-center transition';

const variantClasses: Record<Variant, string> = {
    filled: 'bg-primary text-white border border-primary disabled:bg-custom-bg-disabled disabled:border-custom-bg-disabled disabled:pointer-events-none',
    outlined:
        'text-primary border border-primary bg-transparent disabled:pointer-events-none',
    text: 'text-primary w-fit p-0 h-auto disabled:text-custom-bg-disabled'
};

const CustomButton: React.FC<CustomButtonProps> = ({
    children,
    variant = 'filled',
    className = '',
    ...props
}) => {
    const classes = cn(baseClassName, variantClasses[variant], className);
    return (
        <button className={classes} {...props}>
            {children}
        </button>
    );
};

export default CustomButton;
